//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../no/Builder.js";
import "../no/SelectNXObjectList.js";
import "../no/ScCollector.js";
import "../no/ScCollector.js";
import "../no/SelectObjectList.js";
let d=[[[0,"AttributeOfRootPart",1,0],[0,"AttributeTitles",1,0],[0,"AttributeValues",1,0],[0,"OccurenceOrPrototypeEnum",1,0],[0,"OccurenceOrPrototypeEnumAccordingToAttribute",1,0],[0,"SelectAttributeSpreadsheet",1,0],[1,"SelectBody",0,"SelectNXObjectList",0],[1,"SelectBodyAccordingToAttribute",0,"SelectNXObjectList",0],[1,"SelectComponent",0,"SelectNXObjectList",0],[1,"SelectComponentAccordingToAttribute",0,"SelectNXObjectList",0],[1,"SelectFace",0,"ScCollector",0],[1,"SelectFaceAccordingToAttribute",0,"ScCollector",0],[0,"SelectionFilter",1,0],[0,"SelectionFilterAccordingToAttribute",1,0],[0,"ShowTypeEnum",1,0],[0,"ToggleListDependents",1,0],[0,"Type",1,0],[0,"WizardType",1,0]],[[[],"AddFromDataFileAttributeList",{},0,0],[[],"NewAttribute",{},0,0],[[],"CopyAttribute",{},0,0],[[],"PasteAttribute",{},0,0],[[],"DeleteAttribute",{},0,0],[[],"UndoButton",{},0,0],[[],"EditConfigurationFile",{},0,0]],[]];
SPLM.Tooling.ObjectAttributeManagementBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Tooling.ObjectAttributeManagementBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Tooling.ObjectAttributeManagementBuilder.ShowType = Object.freeze({
    "ShowAttributeOfSelectedObject" : "ShowAttributeOfSelectedObject", "ShowObjectAccordingToAttribute" : "ShowObjectAccordingToAttribute"});

SPLM.Tooling.ObjectAttributeManagementBuilder.FilterType = Object.freeze({
    "Part" : "Part", "Component" : "Component", "SolidBody" : "SolidBody", "Face" : "Face"});

SPLM.Tooling.ObjectAttributeManagementBuilder.OccurenceOrPrototype = Object.freeze({
    "AssignAttributesToOccurence" : "AssignAttributesToOccurence", "AssignAttributesToPrototype" : "AssignAttributesToPrototype"});

SPLM.Tooling.ObjectAttributeManagementBuilder.OccurenceOrPrototypeAccordingToAttribute = Object.freeze({
    "AssignAttributesToOccurence" : "AssignAttributesToOccurence", "AssignAttributesToPrototype" : "AssignAttributesToPrototype"});

SPLM.Tooling.ObjectAttributeManagementBuilder.FilterAccordingToAttributeType = Object.freeze({
    "Part" : "Part", "Component" : "Component", "SolidBody" : "SolidBody", "Face" : "Face"});

SPLM.Tooling.ObjectAttributeManagementBuilder.ShowComponentsType = Object.freeze({
    "ShowAllComponents" : "ShowAllComponents", "OnlyShowComponentsWithAttribute" : "OnlyShowComponentsWithAttribute", "HideComponentsWithAttribute" : "HideComponentsWithAttribute"});

export default SPLM;